function defineEnvironment() {
	let currentUrl = window.location.host;
	let apiUrl;
	switch (currentUrl) {
		case "tmf.staging.pdc.is":
			apiUrl = "https://api.tmf.staging.pdc.is/api";
			break;
		case "trackmyfcev.com":
			apiUrl = "https://api.trackmyfcev.com/api";
			break;
		default:
			apiUrl = "http://api.tmf.dev/api";
			break;
	}
	return apiUrl;
}

export const API_URL = defineEnvironment();

// Auth group
export const REGISTER_URL = "/auth/register";
export const REMINDER_URL = "/auth/password/email";
export const RESET_URL = "/auth/password/reset";
export const RESET_CHECK_URL = "/auth/password/reset-check";
export const LOGIN_URL = "/auth/login";

// Request
export const USER_URL = "/user";
export const REPORT_URL = "/reporting";
export const INPUT_URL = "/refuel";
export const PROFILE_URL = "/profile";



// WEBPACK FOOTER //
// ./src/config.js